import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',

      '& .MuiCardContent-root': {
        padding: theme.spacing(1),
      },

      '& p': {
        fontSize: '1.2rem',
      },
      '& hr': {
        margin: theme.spacing(0.6, 0),
      },
    },
  }),
)
